const TERMS_AND_CONDITIONS_URL =
	'https://www.totango.com/terms-and-conditions-totango-free-trial-and-community-edition';
const PRIVACY_POLICY_URL = 'https://www.totango.com/privacy-policy';

const employeeNumberOptions = [
	{
		key: '50',
		value: '1 - 50',
	},
	{
		key: '100',
		value: '51 - 100',
	},
	{
		key: '200',
		value: '101 - 200',
	},
	{
		key: '500',
		value: '201 - 500',
	},
	{
		key: '1000',
		value: '501 - 1000',
	},
	{
		key: '5000',
		value: '1001 - 5000',
	},
	{
		key: '10000',
		value: '5001 - 10,000',
	},
	{
		key: '50000',
		value: '10,001+',
	},
];

const accountsOptions = [
	{
		key: 'S (100 and under)',
		value: '100 and under',
	},
	{
		key: 'M (up to 1,000)',
		value: 'Up to 1,000',
	},
	{
		key: 'L (up to 50,000)',
		value: 'Up to 50,000',
	},
	{
		key: 'XL (over 50,000)',
		value: '50,001 and over',
	},
];

const companyDescriptionsOptions = [
	{
		key: 'Using another platform, evaluation new',
		value: 'We have a Customer Success platform and evaluating others',
	},
	{
		key: 'CS team in place, no platform yet',
		value: 'We have a CS program but no CS platform (software)',
	},
	{
		key: 'No platform, creating a CS program',
		value: 'We are trying to implement a CS program',
	},
	{
		key: 'Just looking around',
		value: "I'm just looking around",
	},
];

export const dataCenters = {
	eu: 'eu',
	us: 'us',
};

export const dataCenterOptions = [
	{ label: 'EU', value: dataCenters.eu },
	{ label: 'US', value: dataCenters.us },
];

const AUTOMATED_RENEWALS_CANVAS_UPLOADCARE_ID = '4e5a7295-688d-4974-b432-5082fb952a73';
const ONBOARDING_CANVAS_UPLOADCARE_ID = '8a5d474f-48a9-4e43-8b32-88eea1930ca4';
const NPS_CANVAS_UPLOADCARE_ID = '44939a8c-dac6-45d0-a046-db98ce5d78c3';
const DETECT_RISK_UPLOADCARE_ID = '887069ba-f88d-4876-b407-248b673e5b42';
const CUSTOMER_JOURNEY_MARKETPLACE_UPLOADCARE_ID = '0f58e9f9-8fcd-42c5-b423-8dd2dbde1b6c';
export const DEFAULT_SIGNUP_BACKGROUND_ID = '0f58e9f9-8fcd-42c5-b423-8dd2dbde1b6c';

export const BACKGROUND_UPLOADCARE_OPTIONS = {
	'automate-renewals-canvas': AUTOMATED_RENEWALS_CANVAS_UPLOADCARE_ID,
	'onboarding-canvas': ONBOARDING_CANVAS_UPLOADCARE_ID,
	'nps-canvas': NPS_CANVAS_UPLOADCARE_ID,
	'detect-risk-successblock': DETECT_RISK_UPLOADCARE_ID,
	'successbloc-marketplace': CUSTOMER_JOURNEY_MARKETPLACE_UPLOADCARE_ID,
};

export {
	PRIVACY_POLICY_URL,
	TERMS_AND_CONDITIONS_URL,
	accountsOptions,
	employeeNumberOptions,
	companyDescriptionsOptions,
};
